module.exports = __webpack_public_path__ + "6379eec86a4707c9e709e965b11dae6b.MP3";